import { useYMapEntries } from './useYMapEntries';
import { yElements } from '../schema';
import { getDiagramDoc } from '../doc';

export function useAreas() {
    const doc = getDiagramDoc();
    const all = useYMapEntries(doc ? yElements(doc) : null) ?? {};
    return Object.fromEntries(Object.entries(all).filter(([, v]) => v.type === 'area'));
}
